import { useTranslation } from "react-i18next";
import ToolsGrid from "@/components/tools/ToolsGrid";
import useSEO, { canonicalFor } from "@/lib/useSEO";

export default function ToolsHub() {
  const { t } = useTranslation();
  useSEO({
    title: `${t("tools.hub.title")} — Corpora Consultants`,
    description: t("tools.hub.lead"),
    canonical: canonicalFor("/tools"),
    image: canonicalFor("/brand/corpora-og.jpg"),
  });
  return (
    <div className="pt-36 md:pt-44" data-testid="tools-hub-page">
      <section className="max-w-[1480px] mx-auto px-6 md:px-10">
        <div className="overline mb-6">{t("tools.section.eyebrow")}</div>
        <h1 className="display text-4xl sm:text-5xl lg:text-6xl text-[var(--bone)]">
          {t("tools.section.title1")}{" "}
          <span className="display-italic" style={{ color: "var(--pewter)" }}>{t("tools.section.title2")}</span>
        </h1>
        <p className="mt-6 text-[var(--bone-2)] text-base md:text-lg max-w-2xl leading-relaxed">{t("tools.hub.lead")}</p>
      </section>
      <section className="max-w-[1480px] mx-auto px-6 md:px-10 mt-16">
        <ToolsGrid />
      </section>
    </div>
  );
}
